import {
  ALLOWED_MEDIA,
  type ResponsiveImageSource,
} from '@/app/components/media/app-image';
import {
  SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PRESET_THUMBNAIL_DESKTOP_SIZES,
  SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PRESET_THUMBNAIL_SIZES,
  SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_THUMBNAIL_QUALITY,
} from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/constants';

const MOBILE_THUMBNAIL_WIDTHS = [256, 384] as const;
const DESKTOP_THUMBNAIL_WIDTHS = [256, 384] as const;

interface PresetThumbnailSources {
  mobileSrc: ResponsiveImageSource;
  desktopSrc: ResponsiveImageSource;
}

export const getSpartanProductExteriorThreesixtyPresetThumbnailSources = (
  src: string
): PresetThumbnailSources => ({
  mobileSrc: {
    src,
    media: ALLOWED_MEDIA.lgDown,
    sizes: SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PRESET_THUMBNAIL_SIZES,
    widths: MOBILE_THUMBNAIL_WIDTHS,
    params: {
      f: 'webp',
      q: SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_THUMBNAIL_QUALITY,
    },
  },
  desktopSrc: {
    src,
    media: ALLOWED_MEDIA.lgUp,
    sizes: SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PRESET_THUMBNAIL_DESKTOP_SIZES,
    widths: DESKTOP_THUMBNAIL_WIDTHS,
    params: {
      f: 'webp',
      q: SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_THUMBNAIL_QUALITY,
    },
  },
});
